import { render, staticRenderFns } from "./AdminMatchesRequestsTable.vue?vue&type=template&id=371c3ee8&scoped=true"
import script from "./AdminMatchesRequestsTable.vue?vue&type=script&lang=js"
export * from "./AdminMatchesRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c3ee8",
  null
  
)

export default component.exports